import React from 'react';
import AppImage from '@/components/ui/AppImage';
import { trackGalleryView } from '@/lib/analytics';

interface GalleryImage {
  id: string;
  src: string;
  alt: string;
  category: string;
  caption?: string;
  culturalContext?: string;
}

interface GalleryGridProps {
  images: GalleryImage[];
  onImageClick: (image: GalleryImage) => void;
}

const GalleryGrid = ({ images, onImageClick }: GalleryGridProps) => {
  const handleImageClick = (image: GalleryImage) => {
    trackGalleryView(image.id, image.category);
    onImageClick(image);
  };

  if (images.length === 0) {
    return (
      <div className="text-center py-16">
        <p className="font-inter text-lg text-muted-foreground">
          No images found in this category.
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
      {images.map((image) => (
        <div
          key={image.id}
          onClick={() => handleImageClick(image)}
          className="group relative bg-card rounded-lg overflow-hidden shadow-sacred-sm hover:shadow-sacred-lg transition-all duration-300 cursor-pointer"
        >
          <div className="aspect-[4/3] overflow-hidden">
            <AppImage
              src={image.src}
              alt={image.alt}
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
            />
          </div>
          
          <div className="absolute inset-0 bg-gradient-to-t from-foreground/80 via-foreground/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            <div className="absolute bottom-0 left-0 right-0 p-4">
              {image.caption && (
                <p className="font-inter text-sm text-white font-medium mb-1">
                  {image.caption}
                </p>
              )}
              {image.culturalContext && (
                <p className="font-inter text-xs text-white/80">
                  {image.culturalContext}
                </p>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default GalleryGrid;